import { DiditActions } from './DiditActions.jsx';

const descriptor = { key: 'didit', replacesDocumentUploads: true, slots: { 'profile.verification.actions': DiditActions } };

export default descriptor;
